export default __webpack_public_path__ + "static/media/tick.f55b5408.svg";